import { useQuery } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import formsApi from '../api/forms.api';
import { DefaultErrorMessage } from '../displayStrings';
import { Form } from '../types';
import { isNotFoundError } from '../utils/errorUtils';
import { getQriServiceUrl } from '../utils/qriServiceUrl';

export const BaseQueryKey = 'formDetails';

const updateSmartlinkInRichTextFields = async (form: Form, companyId: number) => {
  for (const field of form.fields) {
    if (field.type === 'rich_text' && field.values && field.values[0]) {
      field.values[0].value = await Smartlink.QualioSmartlink.getUpdateSmartlinkTextInRichText(
        field.values[0].value,
        companyId,
        getQriServiceUrl(),
        process.env.REACT_APP_MEDTECH_BACKEND_API_URL,
      );
    }
  }
};

export const useFormDetails = (eventId: number, stepId: number | undefined, formId: number | null | undefined) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();

  return useQuery(
    [BaseQueryKey, formId],
    async () => {
      const form = await formsApi.getForm(companyId, eventId, stepId as number, formId as number);

      await updateSmartlinkInRichTextFields(form, companyId);

      return form;
    },
    {
      enabled: !!formId && !!stepId,
      // A missing form is a terminal outcome: don't retry it (react-query defaults to 3),
      // and let the view render the not-found page instead of firing a generic error toast.
      retry: (failureCount, error) => !isNotFoundError(error) && failureCount < 3,
      onError: (error) => {
        if (isNotFoundError(error)) {
          return;
        }
        showToast({
          description: DefaultErrorMessage,
          status: 'error',
        });
      },
    },
  );
};
